import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {withTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import ButtonStyles from '../Button/Button.scss';
import styles from './LinkButton.scss';

export const LinkButtonComponent = ({
  className,
  href,
  trackFont,
  children,
  onClick,
  target,
  dataHook = 'link-button',
}) => {
  const linkButtonStyles = withoutSize(trackFont);

  return (
    <a
      href={href}
      target={target}
      className={classnames([styles.linkButton, ButtonStyles.button, className])}
      onClick={onClick}
      style={linkButtonStyles}
      rel="noopener noreferrer"
      data-hook={dataHook}
    >
      {children}
    </a>
  );
};

LinkButtonComponent.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  trackFont: PropTypes.object,
  dataHook: PropTypes.string,
};

export const LinkButton = withTrackFont(LinkButtonComponent);
